import { Apps, Build, InsertDriveFile, Image, LocationOn, FitnessCenter, SwapHoriz } from '@material-ui/icons'
import { SyntheticEvent } from 'react';
import { ToolsEnum } from 'src/shared/enum';

export interface IDashboardProps {
}

//#region Location Props (Route Props)
export interface ILocationProps {
	hash?: string;
	pathname?: string;
	search?: string;
	state?: any;
}
//#endregion

export interface IModule {
	Dashboard: IModuleType;
	Tools: IModuleType;
}

export interface IModuleType {
	sortOrder?: number;
	location?: 'sidebar' | 'header' | 'hidden';
	name: string;
	toString: () => string;
	url?: string;
	icon?: any;
	children?: IModuleType[]
}

export const Module: IModule = {
	// Sidebar
	Dashboard: {
		sortOrder: 0,
		location: 'sidebar',
		name: "Dashboard",
		toString: () => 'Dashboard',
		url: '/dashboard',
		icon: Apps
	},
	Tools: {
		name: "Tools",
		toString: () => 'Tools',
		icon: Build,
		children: [
			{
				name: ToolsEnum.EFileAnalyzer,
				toString: () => 'EFile Analyzer',
				url: '/efile-analyzer',
				icon: InsertDriveFile
			},
			{
				name: ToolsEnum.RealSizeViewer,
				toString: () => 'Realsize Viewer',
				url: '/realsize-viewer',
				icon: Image
			}, 
			{
				name: ToolsEnum.Geocoder,
                toString: () => 'Geocoder',
                url: '/geocoder',
                icon: LocationOn
			},
			{
				name: ToolsEnum.VolumetricWeight,
                toString: () => 'Volumetric Weight',
                url: '/volumetric-weight',
                icon: FitnessCenter
			},
			{
				name: ToolsEnum.UnitConverter,
                toString: () => 'UnitConverter',
                url: '/unit-converter',
                icon: SwapHoriz 
			}
		]
	}
};

export interface IMenuInjectedProps {
	open?: (eventOrAnchorEl: SyntheticEvent<any> | HTMLElement) => void;
	close?: () => void;
	onMouseLeave?: (event: SyntheticEvent<any>) => void;
	toggle?: (eventOrAnchorEl: SyntheticEvent<any> | HTMLElement) => void;
	setOpen?: (open: boolean, eventOrAnchorEl: SyntheticEvent<any> | HTMLElement) => void;
	isOpen?: boolean;
	anchorEl?: HTMLElement;
	popupId?: string;
	variant?: 'popover' | 'popper';
}

export interface IFileResponse {
	fileContents: Blob;
	fileDownloadName: string;
}

export interface IErrorResponse {
	code: number;
	message: string;
}
